import Vue from 'vue';
import App from './App.vue';

import './assets/styles/index.less';

const app = new Vue({
	el: '#app',
	render: (h) => h(App),
});

if (!app) console.log(app); // тупо костыль чтобы еслинт не ругался

window.UARM_EXPOSED_VUE_LIB = Vue; // используется как минимум в admin-bundle
window.UARM_EXPOSED_APP_COMPONENT = App; // используется как минимум в admin-bundle
window.UARM_APP_VERSION = process.env.npm_package_version; // исп. в uarm-fe для вывода собственно версии из пекеджа. Доступен здесь благодаря EnvironmentPlugin
